import { DealDto } from '@app/model/deal.model';
import {
    ProductCardEntry,
    transformDealDtoToProductCardEntry,
} from '@app/controls/product-card/product-card.model';

export interface TempDataServiceObjectType {
    store_details: {
        bannerData: {
            banner1: AdvertisingBannerDto[];
            banner2: AdvertisingBannerDto[];
            top_banner: AdvertisingBannerDto[];
        };
    };
}

export interface BestSellerCategories {
    categories: {
        category: string;
        data: ProductCardEntry[];
    }[];
    trendingOffers?: ProductCardEntry[];
}

export interface AdvertisingBanner {
    // TODO: seems only fileName and urlString are used. Remove the rest if this turns out to be true
    fileName: string;
    fileNameDesktop: string;
    urlString: string;
    isProduct: boolean;
    productData: {
        productId: string;
        productUrl: string;
    }[];
    categoryId: string;
}

export interface BestSellerEntryDto {
    id: string;
    product_url: string;
    category_id: string;
    saved_price: string;
    price: string;
    imageurl: string;
    name: string;
    short_description: string;
    spclprice: string;
    currencysymbol: string;
    star_count: string;
    average: number;
    event_start_date: string;
    event_end_date: string;
    banner_images: string[];
}

export interface AdvertisingBannerDto {
    filename: string;
    filename_desktop: string;
    urlstring: string;
    is_product: boolean;
    product_data: {
        product_id: string;
        product_url: string;
    }[];
    categoryid: string;
}

export interface RecentlyViewedDto {
    data: BestSellerEntryDto[];
}

// TODO: this has to be changed to the actual type when we finish the trips-detail component
export interface UpcomingTripDto {
    outlet_name: string;
    location_name: string;
    checkin: string;
    checkout: string;
    pdf_url: string;
}

export interface HomeDealsDto {
    [key: string]: { name: string; deals: DealDto[] };
}

export const transformHomeDealsDtoToBestSellerEntry = (
    homeDealsDto: HomeDealsDto
): BestSellerCategories => {
    const transformedBestSeller: BestSellerCategories = {
        categories: [],
        trendingOffers: homeDealsDto['trending'].deals.map((entry) =>
            transformDealDtoToProductCardEntry(entry)
        ),
    };
    Object.keys(homeDealsDto).forEach((key) => {
        if (key !== 'trending' && key !== 'stateRefreshAt') {
            transformedBestSeller.categories.push({
                category: homeDealsDto[key].name,
                data: homeDealsDto[key].deals.map((entry) =>
                    transformDealDtoToProductCardEntry(entry)
                ),
            });
        }
    });

    return transformedBestSeller;
};
